// /forgot-password — «Восстановление пароля» (025: research Р5): без сеанса, рядом с /login
// и /invite/:token. Почта со «Входа» — из состояния истории браузера, а не из адреса страницы.
import { createFileRoute, useRouterState } from '@tanstack/react-router';
import { PasswordRecoveryPage } from '../features/auth/PasswordRecoveryPage.tsx';
import { recoveryEmailOf } from '../features/auth/recovery-state.ts';

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordRoute,
});

function ForgotPasswordRoute() {
  const email = useRouterState({ select: (state) => recoveryEmailOf(state.location.state) });
  return <PasswordRecoveryPage email={email} />;
}
